// import sendRequest from "../../../shared/utils/sendRequest";
// import { encrypt } from '../../../shared/utils/crypto';
import { useLocation } from "react-router-dom";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import { encryptedData } from "../../utils";

const createLead = (source, leadId, application_form_no) => {
    const fd = new FormData();
    // const location = useLocation();
    // const source = location.pathname.split("/")[1];
    const req = {
        id: leadId,
        application_form_number: application_form_no,
    }
    fd.append('data', encryptedData(req));
    try {
        // sendRequest('/' + source + '/createLeadUpsell2', fd);
    } catch (error) {
        console.error(error);
    }
};

const updateLead = (source, leadId, application_form_no) => {
    const fd = new FormData();
    const req = {
        id: leadId,
        application_form_number: application_form_no
    }
    fd.append('data', encryptedData(req));
    try {
        // sendRequest('/' + source + '/updateLeadUpsell2', fd);
    } catch (error) {
        console.error(error);
    }
};

export { createLead, updateLead };
